"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdInteraction = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../google/protobuf/wrappers");
function createBaseAdInteraction() {
    return {
        adShareOpen: undefined,
        adShareSend: undefined,
        isSubscribed: undefined,
        subscribeButtonTappedTsMs: [],
        adContextMenuOpen: undefined,
    };
}
exports.AdInteraction = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.adShareOpen !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.adShareOpen }, writer.uint32(10).fork()).ldelim();
        }
        if (message.adShareSend !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.adShareSend }, writer.uint32(18).fork()).ldelim();
        }
        if (message.isSubscribed !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isSubscribed }, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.subscribeButtonTappedTsMs) {
            wrappers_1.Int64Value.encode({ value: v }, writer.uint32(34).fork()).ldelim();
        }
        if (message.adContextMenuOpen !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.adContextMenuOpen }, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAdInteraction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.adShareOpen = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.adShareSend = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.isSubscribed = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.subscribeButtonTappedTsMs.push(wrappers_1.Int64Value.decode(reader, reader.uint32()).value);
                    break;
                case 5:
                    message.adContextMenuOpen = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAdInteraction();
        message.adShareOpen = object.adShareOpen ?? undefined;
        message.adShareSend = object.adShareSend ?? undefined;
        message.isSubscribed = object.isSubscribed ?? undefined;
        message.subscribeButtonTappedTsMs =
            object.subscribeButtonTappedTsMs?.map((e) => e) || [];
        message.adContextMenuOpen = object.adContextMenuOpen ?? undefined;
        return message;
    },
};
//# sourceMappingURL=ad_interaction.js.map